export default {
    data() {
        return {
            isOtpApiCalled: false,
            otpSent: false,
            isDisabled: true,
            resendOtp: false,
            timerRunning: false,
            minutes: 5,
            seconds: 0,
            passwordFieldType: 'password',
            confPasswordFieldType: 'password',
            init: false,
            getOTPmsg:false,
            otpLoading: false,
        }
    },
    methods: {
        refreshData() {
            this.form = {
                code: this.$siteSettings?.data && this.$siteSettings?.data.country_code ? this.$siteSettings?.data.country_code : 91,
                mobileNo: "",
                otp: '',
                userName: '',
                password: "",
                confirmPassword: "",
                captchaText: ''
            },
                this.isOtpApiCalled = false,
                this.resendOtp = false,
                this.resendOtpTimer = 0,
                this.timerRunning = false,
                this.minutes = 0,
                this.seconds = 0,
                this.otpSent = false,
                this.passwordFieldType = 'password',
                this.confPasswordFieldType = 'password',
                this.init = false,
                this.phnInit=false,
                this.otpBtnInit=false,
                this.getOTPmsg= false,
                this.otpLoading = false;
        },
        sendOtpCall(auth_type) {
            if(this.form.mobileNo){
                this.sendOtpServiceCall(auth_type);
            }
        },
        sendOtpServiceCall(auth_type) {
            this.isOtpApiCalled = true;
            this.otpLoading = true;
            let data = {
                type: auth_type,
                mobile: this.form.mobileNo, 
                countrycode: this.form.code
            }
            this.$apiCall('post', 'SEND_OTP', data).then(response => {
                if (response) {
                    if (response.status == 200) {
                        if (response?.data?.status == 0 || response?.data?.error) {
                            this.$errorToast(response?.data?.error);
                        } 
                        this.otpSent = true; // OTP sent successfully, disable phone number field
                        this.isDisabled = false;
                        this.$successToast(response.data.data)
                        this.resendOtp = true;
                        this.timerRunning = true;
                        this.minutes = 5;
                        this.seconds = 0;
                        this.setResendTimer();
                        this.otpBtnInit = false;
                        this.otpLoading = false;
                    }
                }
            }).catch(error => {
                this.getOTPmsg = false;
                this.isOtpApiCalled = false;
                this.otpLoading = false;
                if (error)
                    this.$errorToast(error[0])
            });
        },
        getOtp() {
            return this.form.otp.toString();
        },
        togglePasswordVisibility(fieldName) {
            if(fieldName == 'password'){
                this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
            } else {
                this.confPasswordFieldType = this.confPasswordFieldType === 'password' ? 'text' : 'password';
            }
        },
        setResendTimer() {

            const countdown = () => {
                if (this.minutes === 0 && this.seconds === 0) {
                    this.timerRunning = false;
                    // Timer has expired, you can perform any action here
                } else {
                    if (this.seconds === 0) {
                        this.minutes--;
                        this.seconds = 59;
                    } else {
                        this.seconds--;
                    }
                    setTimeout(countdown, 1000);
                }
            };

            setTimeout(countdown, 1000);
        },
        formatTime(value) {
            return value < 10 ? `0${value}` : value;
        },
    }
}